'use strict';

angular.module('bringgApp.filters').filter('percent', function () {
	return function (value) {
		return (value * 100).toFixed(1) + '%';
	};
});
